import styled from "styled-components";
export const MaterialTableText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 15px;
`;
export const MaterialOrderLinkedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const MaterialOrderChildLinkedWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;
export const MaterialOrderLinkedTitle = styled.div`
    color: #333739;
    text-align: left;
    font-family: "Noto Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
`